import $ from "jquery";
import 'lightbox2';
import '../../global/js/cms.js';

$(document).ready(function() {
    $('.img a[href$=jpg], .img a[href$=png], .img a[href$=gif]').each(function() {
        $(this).attr('data-lightbox', 'image');
    });
});
